import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import { createTeam, resetCreateTeamLoading } from '../../store/TeamManagementActions'
import { clearNotification } from '../../../../common/notifications/NotificationActions'
import CreateTeam, { ICreateTeam, ICreateTeamDispatchProps } from './CreateTeam'
import { getCreatedDivisionId, getCreateTeamLoading } from '../../store/TeamManagementSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: ICreateTeam) => ({
  ...ownProps,
  createdDivisionId: getCreatedDivisionId(state),
  createTeamLoading: getCreateTeamLoading(state),
  selectedGroupId: ownProps.selectedGroupId,
})

const mapDispatchToProps: ICreateTeamDispatchProps = {
  createTeam,
  resetCreateTeamLoading,
  clearNotification,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateTeam)
